<template>
  <div id="page-user-list">
    <vx-title-bar :route="$route" :isRTL="$vs.rtl"> </vx-title-bar>
    <vx-card :title="this.$t('OrganisationUser.List')" class="mb-base">
      <organisation-user-list
        :organisationId="activeOrganisation.id"
      ></organisation-user-list>
    </vx-card>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import OrganisationUserList from '../organisation/OrganisationUserList.vue'

export default {
  data () {
    return {
      organisation_data: null,
      organisation_not_found: false
    }
  },
  components : {
    OrganisationUserList
  },
  methods: {
  },
  created () {

  },
  computed: {
    ...mapGetters([
      "activeOrganisation"
    ])
  }
}

</script>

